var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPostcode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1244 8H4.23957C3.55497 8 3 8.5548 3 9.23918V19.5198C3 20.2041 3.55497 20.7589 4.23957 20.7589H20.1244C20.809 20.7589 21.3639 20.2041 21.3639 19.5198V9.23918C21.3639 8.5548 20.809 8 20.1244 8Z",
    stroke: "#8A92A6",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7783 20.3816L14.3018 13.9126",
    stroke: "#8A92A6",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.54004 20.3719L10.3352 13.8208",
    stroke: "#8A92A6",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9155 8.29468L12.627 15.268C12.5404 15.341 12.4311 15.3816 12.3178 15.3829C12.2046 15.3841 12.0944 15.346 12.0063 15.2749L3.49365 8.43236",
    stroke: "#8A92A6",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 12C10.0147 12 8 9.98528 8 7.5C8 5.01472 10.0147 3 12.5 3C14.9853 3 17 5.01472 17 7.5C17 9.98528 14.9853 12 12.5 12Z",
    fill: "white",
    stroke: "#8A92A6",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.33 6.38L9.81667 8.54667H11.3633V9H9.2V8.54667L10.7167 6.38H9.22667V5.92333H11.33V6.38ZM12.4586 9H11.9019V5.92333H12.4586V9ZM14.2604 5.88333C14.6648 5.88333 14.9415 5.95222 15.0904 6.09C15.2415 6.22778 15.317 6.48889 15.317 6.87333C15.317 7.25778 15.2448 7.51889 15.1004 7.65667C14.9582 7.79444 14.7026 7.86333 14.3337 7.86333C14.1093 7.86333 13.8993 7.85111 13.7037 7.82667V9H13.147V5.92333C13.4293 5.89667 13.8004 5.88333 14.2604 5.88333ZM13.7037 6.34333V7.41H14.247C14.4448 7.41 14.5793 7.37333 14.6504 7.3C14.7215 7.22444 14.757 7.08222 14.757 6.87333C14.757 6.66444 14.7215 6.52444 14.6504 6.45333C14.5793 6.38 14.4448 6.34333 14.247 6.34333H13.7037Z",
    fill: "#8A92A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPostcode);
export default __webpack_public_path__ + "static/media/ic_postcode.8e87221d250abe0ca6688e69316d7fe3.svg";
export { ForwardRef as ReactComponent };